import { onBootstrap } from '@/bootstrap'
import { Injector } from '@/config/dependency-injection'
import { getModule } from 'vuex-module-decorators'
import { ResourceDataSource } from '@/business/resource/resource-data-source'
import { ResourceModule } from '@/business/resource/store/resource-module'

onBootstrap.add(({ store }) => {
  Injector.bindSingleton(ResourceDataSource)

  Injector.bindLazy(ResourceModule, () => {
    store.registerModule(ResourceModule.STORE_NAME, ResourceModule)

    return getModule<ResourceModule>(ResourceModule, store)
  })
})
